export default __webpack_public_path__ + "static/media/riverwalk_form.b6a4ce24.jpg";